export default __webpack_public_path__ + "static/retail_clothing_casestudy-855262bcfdf76de3489cb3e554868a13.svg";